import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const InstitutionSignInDirective = angularDirectiveToReact('signIn', {
    urlPrefix: 'urlPrefix',
});

export function InstitutionSignInComponent() {
    const [key, params] = useAngularToReactRoute<{ urlPrefix: string }>();
    return <InstitutionSignInDirective key={key} {...params} />;
}
